import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { Formik, Form as Form$1 } from 'formik';
import { getFieldValue } from './utils/get-field-value.js';
import { getFormValidators } from './utils/validators.js';
import { CoreField } from './fields/core-field.js';
import { SubmitButton } from './fields/submit-button.js';
var Form = function Form(_ref) {
  var onSubmit = _ref.onSubmit,
    onFormChange = _ref.onFormChange,
    id = _ref.id,
    fields = _ref.fields,
    hideSubmitButton = _ref.hideSubmitButton,
    feedback = _ref.feedback,
    submitDisabled = _ref.submitDisabled,
    submitButtonText = _ref.submitButtonText;
  var initialValues = fields.reduce(function (acc, field) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, field.name, getFieldValue(field)));
  }, {});
  var onFormChangeHandler = useCallback(function (e) {
    onFormChange && onFormChange(e);
  }, [onFormChange]);
  return /*#__PURE__*/React.createElement("div", {
    "data-object-type": "core-form"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: getFormValidators(fields, id),
    id: id
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      errors = _ref2.errors,
      touched = _ref2.touched,
      values = _ref2.values,
      isSubmitting = _ref2.isSubmitting,
      isValidating = _ref2.isValidating;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form$1, {
      id: id,
      onSubmit: handleSubmit,
      noValidate: true
    }, fields.map(function (field) {
      return /*#__PURE__*/React.createElement(CoreField, {
        changeHandler: hideSubmitButton ? onFormChangeHandler : undefined,
        key: field.name,
        field: field,
        errors: errors,
        touched: touched,
        values: values
      });
    }), !hideSubmitButton && /*#__PURE__*/React.createElement(SubmitButton, {
      submitDisabled: submitDisabled,
      submitButtonText: submitButtonText
    })), !isValidating && isSubmitting && feedback);
  }));
};
Form.displayName = "Form";
export { Form };